'use client';

import { ActionButtonsView } from '@/components/action-buttons/ActionButtonsView';
import { useActionButtonsController } from '@/components/action-buttons/use-action-buttons-controller';
import type { ActionButtonsButtonRowBindings } from '@/components/action-buttons/action-buttons-view.types';
import type { ActionButtonsControllerValue } from '@/components/action-buttons/action-buttons-controller.types';

type ActionButtonsProps = Pick<ActionButtonsButtonRowBindings, 'activeTable' | 'onSetActiveTable'>;

type ActionButtonsScope = 'top' | 'bottom';

type ActionButtonsScopedProps = ActionButtonsProps & {
    controlsScope?: ActionButtonsScope;
    controllerValue?: ActionButtonsControllerValue;
    renderModals?: boolean;
};

const ActionButtons = ({
    activeTable,
    onSetActiveTable,
    controlsScope,
    controllerValue,
    renderModals = true,
}: ActionButtonsScopedProps) => {
    const localControllerValue = useActionButtonsController({ activeTable });
    const { buttonRowBindings, modalsBindings } = controllerValue ?? localControllerValue;
    const showAccountTopUpButton =
        controlsScope === undefined
            ? buttonRowBindings.showAccountTopUpButton
            : controlsScope === 'top' && buttonRowBindings.isAccountLimitZero;

    return (
        <div data-controls-group="action-buttons" data-controls-scope={controlsScope}>
            <ActionButtonsView
                buttonRowBindings={{ ...buttonRowBindings, onSetActiveTable, showAccountTopUpButton }}
                modalsBindings={{ ...modalsBindings, onSetActiveTable }}
                renderModals={renderModals}
            />
        </div>
    );
};

export default ActionButtons;
